// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".array-list-grouped>.box{position:relative;display:block}.array-list-grouped>.box>.remove{position:absolute;top:0;right:0}.array-list-grouped>.box>.info-box{margin-bottom:0;padding-right:25px}", ""]);
// Exports
module.exports = exports;
